import React, { useContext, useEffect } from 'react';
import { initAxios } from '../services/network/api';

import { FallbackProps } from 'react-error-boundary';
import SentryErrorBoundary from './SentryErrorBoundary';
import AppLoader from './AppLoader';
import Form from './form/Form';
import FormFooter from './form/FormFooter';
import FormHeader from './form/FormHeader';
import { ExperimentationContext } from './context/ExperimentationContext';
import { KeycloakContext } from './context/KeycloakContext';
import { useKeycloakAuthContext } from '../hooks';
import { useExperimentation } from '../hooks/useExperimentation';
import { AppShopContext } from './context/AppShopContext';

const DOMAINS_WITH_CONTACT_METHODS_DEPLOYED = ['zooplus.fr', 'zooplus.co.uk', 'zooplus.ie'];
const App: React.FC<{}> = () => {
  const appShopContext = useContext(AppShopContext);
  const keycloakContext = useKeycloakAuthContext();
  const experimentation = useExperimentation(keycloakContext, appShopContext.domain);

  useEffect(() => {
    initAxios();
  }, []);

  const fallbackRender = ({ error, resetErrorBoundary }: FallbackProps) => {
    return (
      <div>
        <div>
          <div>ERROR :</div>
          <div>{error?.message}</div>
        </div>
        <div>
          <button onClick={resetErrorBoundary}>RESET</button>
        </div>
      </div>
    );
  };

  return (
    <SentryErrorBoundary fallbackRender={fallbackRender}>
      <div className="main">
        <AppLoader>
          <KeycloakContext.Provider value={keycloakContext}>
            <ExperimentationContext.Provider value={experimentation}>
              <div className="contactForm" data-test="contactForm.container">
                <FormHeader />
                <Form />
                {!DOMAINS_WITH_CONTACT_METHODS_DEPLOYED.includes(appShopContext.domain) && (
                  <FormFooter />
                )}
              </div>
            </ExperimentationContext.Provider>
          </KeycloakContext.Provider>
        </AppLoader>
      </div>
    </SentryErrorBoundary>
  );
};

export default App;
